import React from 'react';
import './FacebookPageIcon.pcss';
import { useSelector } from 'react-redux';
import noImage from 'assets/icons/contact_noimage.svg';
import { StoreState } from '@mm/state/store-interfaces';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { useIsLeadGeneratorBuilderRoute } from '../../../../modules/FreeLeadGenerator/use-is-lead-generator-builder-route';
import { ImageWithFallback } from '../../../components/ImageWithFallback/ImageWithFallback';

export const FacebookPageIcon = () => {
  const isLeadGeneratorRoute = useIsLeadGeneratorBuilderRoute();

  const activeFacebookPage = useSelector((state: StoreState) =>
    activeFacebookPageSelector(state),
  );
  const facebookPageIcon = activeFacebookPage?.squarePicture || noImage;

  if (!isLeadGeneratorRoute) {
    return (
      <div className="facebook-page-icon">
        <ImageWithFallback
          src={facebookPageIcon}
          fallbackImage={noImage}
          className="facebook-page-icon__page-icon"
          alt="Facebook Page Logo"
        />
      </div>
    );
  }

  return null;
};
